<template>
  <div class="popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="popup-content bg-white w-1/3 py-5 relative rounded-lg shadow-lg">
      <div class="flex font-c7 text-c24 px-5">
        Suppression
      </div>

      <div class="mt-10 text-center">
        <icon
          :data="icons.ic_deletePopup"
          height="122"
          width="122"
          class="mx-auto"
          original
        />

        <div class="w-3/5 mx-auto mt-3">
          <p class="text-gray-600 mb-3">
            Etes-vous sûr de vouloir procéder ?
          </p>

          <div
            class="font-semibold text-gray-800"
            v-if="selectedItem"
          >
            <!-- {{ selectedItem.person.firstName }} {{ selectedItem.person.lastName }} -->
          </div>
        </div>
      </div>

      <div class="mt-5">
        <div class="flex justify-end items-center mt-5 mx-5 gap-3">
          <button
            class="font-c5 text-gray-600 px-7 py-3 rounded-8 border border-gray-300 hover:bg-gray-50"
            @click="$emit('closeDeletePopup', false)"
          >
            Annuler
          </button>

          <button
            class="bg-red-500 text-white px-7 py-3 rounded-8 bg-red font-c6"
            @click="confirmDelete()"
          >
            Supprimer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ic_deletePopup from "@/assets/icons/ic_deletePopup.svg"
import { deleteAdmin } from "../allFunctions"
import axios from 'axios' // axios pour requêtes HTTP
import store from "../../../store";

export default {
  name: 'DeletePopup',

  props: {
    showPopup: {
      type: Boolean,
      required: true
    },
    selectedId: {
      type: Number,
      required: true
    }
  },

  emits: ['closeDelete', 'confirmDelete', 'close', 'closeDeletePopup' ],

  data() {
    return {
      icons: {
        ic_deletePopup
      }
    }
  },

  methods: {
    async confirmDelete() {
      console.log('ID reçu pour suppression:', this.selectedId)
      
      if (!this.selectedId) {
        this.$toast.error('Aucun administrateur sélectionné')
        return
      }

      this.charge = true
      
      try {
        const response = await deleteAdmin(this.selectedId)
        console.log('Réponse de suppression:', response)
        this.$toast.success('Administrateur supprimé avec succès')
        this.charge = true
        this.closeDeletePopup()
        // Recharger la liste des administrateurs
        this.getAllAdmin()
      } catch (error) {
        // console.log('Erreur lors de la suppression:', error)
        this.charge = false
        this.$toast.error('Une erreur est survenue lors de la suppression')
      }
    },
  }
}
</script>

<style scoped>
.annulerr {
  background-color: #EFF4FB;
}

.save {
  background-color: #F35D49;
}

.colorBorderB {
  border-bottom: 3px solid #E7EEF8;
}

.bgInpout {
  /* background-color: #F0F2F7; */
  border: 1px solid #F0F2F7
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.popup-content {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 25rem;
}

.relative {
  position: relative;
}
</style>
